module.exports = __webpack_public_path__ + "assets/img/engagement_large.d1cbb9e6.webp";